module.exports = __webpack_public_path__ + "static/media/desktopSH01.1a6e542d.jpg";